<template>
<div>
  <div class="container">
    <form action="" class="form-horizontal">
      <div class="form-group label">
        <!-- <vs-input label="Id" type="text" class="inputx" v-model="form.id" disabled/><br> -->
        <vs-input label="Nombre De Usuario" type="text" class="inputx" v-model="form.username" disabled/><br>
        <vs-input label="Email" type="text" class="inputx" v-model="form.email" disabled/><br>
        <vs-input label="Contraseña" type="text" class="inputx" v-model="form.password"/><br>
        <vs-select class="ps_select" placeholder="autocomplete" autocomplete label="Rol" v-model="role">
        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in roles"/>
        </vs-select><br>
        <vs-button class="bx bxs-paint-roll ml-3" @click="postUser()" color="darkgreen" type="border" icon="update">Actualizar</vs-button>
      </div>
    </form>
  </div>
  <br><br>
  <vs-alert class="ps_alert" color="danger" v-if="show">
        {{msg}}
  </vs-alert>
  <vs-alert class="ps_alert" color="success" v-if="show1">
        {{msg}}
  </vs-alert>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "userEdit",
    props:{
      id: String
    },
    components: {
},
    data:()=>({
    msg: '',
    show: false,
    show1: false,
    role: String,
    roles: Array,
    form: {
        "id" : "" ,
        "username" : "",
        "email" : "",
        "password" : "",
        "role_id" : "",
    },
    error_msg: ''
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    getInfoUsers(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/userList', { params: {user_id:this.id} }).then(response => {
      this.form.id = response.data[0].id
      this.form.username = response.data[0].username
      this.form.email = response.data[0].email
      this.form.password = response.data[0].password
      this.form.role_id = response.data[0].role_id
      this.getRoles()
      })
      .catch((error) => {
        this.error_msg = error.response.data
      })
    },
    getRoles(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/roleList').then(response => {
      this.roles = response.data
      this.role = this.form.role_id
      })
      .catch((error) => {
        this.error_msg = error.response.data
      })
    },
    postUser(){
      const url_api = this.$store.state.url_api
      this.form.role_id = this.role
      axios.post(url_api + 'api/userUpdate', this.form).then(response => {
        if (response.data == 'isOk'){
          this.show = false
          this.show1 = true
          this.msg = 'Successfully updated'
        }
        else{
          this.show = true
          this.show1 = false
          this.msg = response.data
        }
      })
      .catch((error) => {
        this.error_msg = error.response.data
      })
    },
  },
  mounted(){
  this.getInfoUsers()
  }
}
</script>
<style>
  .ps_alert{
    margin-top: 1em;
  }
  .label{
      text-align: left;
    }
  .vs-select--label{
    color: #000000B3;
  }
  .vs-select--item{
    color: darkgreen;
  }

  element.style {
      font-weight: bold;
  }
  .vs-select-primary .vs-select--item.activex {
      background: rgb(23, 83, 65);
      color: white;
  }
</style>